<script>
  import Breadcrumbs from './Breadcrumbs.svelte'
</script>

<div class="panel w-full relative p-6 flex flex-col h-full overflow-hidden">
  <Breadcrumbs />

  <slot />
</div>
